export const ZONE = {}
export const upload = async () => ({ key: "" })
export default { ZONE, upload }
